import React from 'react';
import styles from './Stepper.module.css';

interface Step {
  order: number,
  label: string
}

export default function Stepper ({ step = 1 }: { step: number }): React.ReactElement {
  const DONE_STEP = 'is-done';
  const CURRENT_STEP = 'is-current';
  const STEPS: Step[] = [
    {
      order: 1,
      label: 'Enregistrement'
    },
    {
      order: 2,
      label: 'Traitement SAV'
    },
    {
      order: 3,
      label: 'Restitution'
    }
  ];

  return (
    <>
      <h1 className="headline is-level-2">Suivi de dossier</h1>
      <div className="row">
        <div className="stepper">
          { STEPS.map((s: Step, i: number) => {
            return (
              <div
                key={ i }
                className={ `${ s.order === step ? CURRENT_STEP : '' } ${ s.order < step ? DONE_STEP : '' } step ${ styles.step }` }
                data-label={ s.label }>
                { s.order }
              </div>
            );
          }) }
        </div>
      </div>
    </>
  );
}